import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import SettingsPage from '../partials/SettingsPage';
import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';

import ItemLine from './ItemLine';

import { Button, Text, H2, H4, Panel, Dropdown, Small, Search, Collapse, Box, Switch, Pagination, Input } from '@bigcommerce/big-design';
import { ArrowDropDownIcon } from '@bigcommerce/big-design-icons';

import { updateSelectedItems, searchProducts, resetProducts } from '../../redux/actions/products';
import { getCategories } from '../../redux/actions/categories';

import { assignmentsCreate, reset } from '../../redux/actions/assignments';

const CreateSupplierAssignments = ({ payload, setActiveTab, assignments, activeSupplier, isSearching, searchedProducts, searchedProductsPagination, searchedVariants, selectedProductList, categories, submitSearch, loadCategories, setSelectedProductList, createAssignments, resetAssignments, resetProductSearch }) => {
  const [submitted, setSubmitted] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [inStockFilter, setInStockFilter] = useState(false);
  const [purchasingDisabledFilter, setPurchasingDisabledFilter] = useState(false);
  const [categoryFilter, setCategoryFilter] = useState();

  const [assignmentValues, setAssignmentValues] = useState({
    'supplierPrices': { 'product': {}, 'variant': {} },
    'minOrders': { 'product': {}, 'variant': {} },
    'supplierSkus': { 'product': {}, 'variant': {} },
    'orderMultiples': { 'product': {}, 'variant': {} },
    'packQuantities': { 'product': {}, 'variant': {} },
  })

  const [enqueueSearch, setEnqueueSearch] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    resetProductSearch();
    resetAssignments();
    loadCategories(payload);
    setAssignmentValues({
      'supplierPrices': { 'product': {}, 'variant': {} },
      'minOrders': { 'product': {}, 'variant': {} },
      'supplierSkus': { 'product': {}, 'variant': {} },
      'orderMultiples': { 'product': {}, 'variant': {} },
      'packQuantities': { 'product': {}, 'variant': {} },
    });
    setSelectedProductList({ variants: {}, products: {} });
  }, []);

  useEffect(() => {
    if(assignments.status === 'created') {
      setActiveTab('view');
    }
  }, [assignments]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if(searchTerm !== ''){
        setCurrentPage(1);
        handleSearch(searchTerm, 1);
      }
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [searchTerm, 500]);

  const handleSearch = (searchTerm, page) => {
    if(!isSearching) {
      setEnqueueSearch(null);
      submitSearch(payload, searchTerm, inStockFilter, purchasingDisabledFilter, categoryFilter, page);
    } else {
      setEnqueueSearch(searchTerm);
    }
  }

  useEffect(() => {
    if(!isSearching) {
      readySearch();
    }
  }, [isSearching]);

  const readySearch = () => {
    if(enqueueSearch) {
      submitSearch(payload, enqueueSearch, inStockFilter, purchasingDisabledFilter, categoryFilter, currentPage);
      setEnqueueSearch(null);
    }
  }

  const toggleInStockFilter = () => {
    setInStockFilter(!inStockFilter);
  }

  const togglePurchasingDisabledFilter = () => {
    setPurchasingDisabledFilter(!purchasingDisabledFilter);
  }

  const categoryItems = () => {
    let items = [];

    Object.entries(categories.categories).map(([key, name]) =>
      items.push(
        {
          content: name,
          onItemClick: (event) => switchCategoryFilter(event, setCategoryFilter),
          hash: key
        }
      )
    )

    return items;
  }

  const switchCategoryFilter = (event, setter) => {
    let categoryId = event.hash;
    setter(categoryId);
  }

  const setProductResultPage = (page) => {
    setCurrentPage(page);
    handleSearch(searchTerm, page);
  }

  const clearCategory = () => {
    setCategoryFilter(null);
  }

  const validateTerm = (event) => {
    let value = event.target.value;

    setSearchTerm(value);
  }

  const selectAllSearched = () => {
    let productSection = selectedProductList.products;
    let variantsSection = selectedProductList.variants;

    searchedProducts.forEach((product) => {
      let productInList = Object.keys(productSection).indexOf(String(product.Id)) > -1;
      let productLevelTracked = ((product.inventory_tracking === 'product') || (product.inventory_tracking === 'none' && !(searchedVariants[product.id]?.length > 0)) );
      let productAssigned = assignments.itemAssignments[`${product.id}/null`]?.find(assignment => assignment?.key === `Supplier-${activeSupplier.id}`);

      if ( !productInList && productLevelTracked && !productAssigned ) {
        productSection[String(product.id)] = {
          productId: product.id,
          imageUrl: product.primary_image?.url_tiny,
          fullImageUrl: product.primary_image?.url_standard,
          options: false,
          name: product.name,
          quantity: product.inventory_level,
          price: product.price,
          binPickingNumber: product.bin_picking_number
        }
      }

      searchedVariants[product.id]?.forEach((variant) => {
        let variantInList = Object.keys(variantsSection).indexOf(String(variant.Id)) > -1;
        let variantAssigned = assignments.itemAssignments[`${product.id}/${variant.id}`]?.find(assignment => assignment?.key === `Supplier-${activeSupplier.id}`);

        if (!variantInList && !variantAssigned) {
          variantsSection[String(variant.id)] = {
            productId: product.id,
            imageUrl: product.primary_image?.url_tiny,
            fullImageUrl: product.primary_image?.url_standard,
            options: variant.option_values,
            name: variant.name || product.name,
            quantity: variant.inventory_level,
            price: variant.price || product.price,
            binPickingNumber: variant.bin_picking_number
          }
        }
      })
    })

    setSelectedProductList({ ...selectedProductList });
  }

  const setSupplierPrice = (itemId, type, event) => {
    let assignValues = {...assignmentValues};
    assignValues.supplierPrices[type][itemId] = event.target.value;

    setAssignmentValues(assignValues);
  }

  const setSupplierMinOrder = (itemId, type, event) => {
    let assignValues = {...assignmentValues};
    assignValues.minOrders[type][itemId] = parseInt(event.target.value).toString();

    setAssignmentValues(assignValues);
  }

  const setSupplierSku = (itemId, type, event) => {
    let assignValues = {...assignmentValues};
    assignValues.supplierSkus[type][itemId] = event.target.value;

    setAssignmentValues(assignValues);
  }

  const setOrderMultiple = (itemId, type, event) => {
    let assignValues = {...assignmentValues};
    assignValues.orderMultiples[type][itemId] = parseInt(event.target.value).toString();

    setAssignmentValues(assignValues);
  }

  const setPackQuantity = (itemId, type, event) => {
    let assignValues = {...assignmentValues};
    assignValues.packQuantities[type][itemId] = parseInt(event.target.value).toString();

    setAssignmentValues(assignValues);
  }

  const deselectAllSelected = () => {
    setSelectedProductList({ variants: {}, products: {} });
  }

  const validatePage = (event) => {
    let page = event.target.value;

    if (page < 1) {
      page = 1;
    }

    if (page > searchedProductsPagination.total_pages) {
      page = searchedProductsPagination.total_pages;
    }

    setCurrentPage(page);
  }

  const submitPage = () => {
    handleSearch(searchTerm, currentPage);
  }

  const handleSubmit = () => {
    setSubmitted(true);
    createAssignments(payload, activeSupplier.id, selectedProductList, assignmentValues);
  }

  return (
    <>
      <Panel>
        <div className="full-width">
          <Box marginBottom="medium">
            <H4>Catalog Search</H4>
            <Search onChange={validateTerm} onSubmit={() => handleSearch(searchTerm)} value={searchTerm} />
            <Collapse title="Filters">
              <div className="background-darken padding-20 flex-container">
                <div className="flex-1">
                  <H4>In Stock</H4>
                  <Switch checked={inStockFilter} onChange={toggleInStockFilter} />
                </div>
                <div className="flex-1">
                  <H4>Purchasing Disabled</H4>
                  <Switch checked={purchasingDisabledFilter} onChange={togglePurchasingDisabledFilter} />
                </div>
                <div className="flex-2">
                  <H4>Cagetory</H4>
                  { !categories.isFetching && categories.status === "success" &&
                    <>
                      <Dropdown
                        items={categoryItems()}
                        maxHeight={250}
                        placement="bottom-start"
                        toggle={<Button iconRight={<ArrowDropDownIcon />}>{categories.categories[categoryFilter] || "Select Category"}</Button>}
                      />
                      <Button variant="subtle" className="left-15 bottom-5" onClick={() => clearCategory()}>
                        Clear Category
                      </Button>
                    </>
                  }
                  { categories.isFetching &&
                    <LoadingSpinner size="xxSmall" statusText="Loading categories"/>
                  }
                </div>
              </div>
              <hr/>
            </Collapse>
          </Box>
        </div>
        <Button 
            className="top-5"
            onClick={() => selectAllSearched()}
            disabled={ isSearching || ((!searchedProducts && !searchedVariants ) || (searchedProducts.length === 0 && searchedVariants.length === 0)) }
          >
            Select All Searched Items
          </Button>
          
          <Button
            className="top-5 left-15"
            onClick={() => deselectAllSelected()}
            disabled={ isSearching || ((Object.keys(selectedProductList.products).length + Object.keys(selectedProductList.variants).length) === 0) }
          >
            Deselect All Selected Items
          </Button>
      </Panel>


      <Panel>
        { !isSearching && searchedProducts === null && searchTerm === '' &&
          <Box
            backgroundColor="primary10"
            border="box"
            borderRadius="normal"
            padding="medium"
          >
            <H4>Search Results</H4>
            <Text>
              Search your store's catalog above to see live results here
            </Text>
          </Box>
        }

        { isSearching && <LoadingSpinner size="small" statusText="Searching products" /> }

        { !isSearching && searchedProducts !== null && 
          <>
            <Button
              onClick={() => handleSubmit()}
              disabled={ submitted || ((Object.keys(selectedProductList.products).length + Object.keys(selectedProductList.variants).length) === 0) }
              isLoading={ submitted }
            >
              Submit New Product Assignments
            </Button>
            
            <div>
              { searchedProductsPagination.total_pages > 1 &&
                <div className="flex-container">
                  <div className="flex-1">
                    <Pagination
                      currentPage={searchedProductsPagination.current_page}
                      itemsPerPage={50}
                      itemsPerPageOptions={[]}
                      onItemsPerPageChange={null}
                      onPageChange={(newPage) => setProductResultPage(newPage)}
                      totalItems={searchedProductsPagination.total}
                    />
                  </div>
                  <div className="flex-1">
                    <div className="flex-container">
                      <div className="flex-1">
                        <div className="right-15">
                          <Input
                            required
                            onChange={validatePage}
                            placeholder="Page"
                            value={currentPage}
                            type="number"
                            disabled={submitted}
                          />
                        </div>
                      </div>

                      <div className="flex-8">
                        <Text as="span">
                          of {searchedProductsPagination.total_pages} pages &nbsp;
                        </Text>

                        <Button className="left-15" onClick={() => submitPage()} disabled={submitted}>Set Page</Button>
                      </div>
                    </div>
                  </div>
                </div>
              }

              { searchedProducts?.map(product => 
                <>
                  <ItemLine
                    payload={payload}
                    type={'product'}
                    productId={product.id}
                    itemId={product.id}
                    options={false}
                    name={product.name}
                    imageUrl={product.primary_image?.url_tiny}
                    fullImageUrl={product.primary_image?.url_standard}
                    rowId={product.id}
                    price={product.price}
                    quantity={product.inventory_level}
                    inventoryTracking={product.inventory_tracking}
                    hasVariants={searchedVariants[product.id]?.length > 0}
                    binPickingNumber={product.bin_picking_number}
                    supplierPrice={assignmentValues.supplierPrices.product[product.id]}
                    minOrder={assignmentValues.minOrders.product[product.id]}
                    supplierSku={assignmentValues.supplierSkus.product[product.id]}
                    setSupplierPrice={setSupplierPrice}
                    setSupplierMinOrder={setSupplierMinOrder}
                    setSupplierSku={setSupplierSku}
                    supplierId={activeSupplier.id}
                    submitted={submitted}
                    setOrderMultiple={setOrderMultiple}
                    orderMultiple={assignmentValues.orderMultiples.product[product.id]}
                    setPackQuantity={setPackQuantity}
                    packQuantity={assignmentValues.packQuantities.product[product.id]}
                  />
                  { searchedVariants[product.id]?.map(variant =>
                    <ItemLine
                      payload={payload}
                      type={'variant'}
                      productId={product.id}
                      itemId={variant.id}
                      name={product.name}
                      imageUrl={product.primary_image?.url_tiny}
                      fullImageUrl={product.primary_image?.url_standard}
                      options={variant.option_values}
                      price={variant.price || product.price}
                      quantity={variant.inventory_level}
                      inventoryTracking={false}
                      hasVariants={false}
                      binPickingNumber={variant.bin_picking_number}
                      supplierPrice={assignmentValues.supplierPrices.variant[variant.id]}
                      minOrder={assignmentValues.minOrders.variant[variant.id]}
                      supplierSku={assignmentValues.supplierSkus.variant[variant.id]}
                      setSupplierPrice={setSupplierPrice}
                      setSupplierMinOrder={setSupplierMinOrder}
                      setSupplierSku={setSupplierSku}
                      supplierId={activeSupplier.id}
                      submitted={submitted}
                      setOrderMultiple={setOrderMultiple}
                      orderMultiple={assignmentValues.orderMultiples.variant[variant.id]}
                      setPackQuantity={setPackQuantity}
                      packQuantity={assignmentValues.packQuantities.variant[variant.id]}
                    />
                  )}
                </>
              )}
            </div>
          </>
        }


      </Panel>
    </>
  )

}

const mapStateToProps = state => ({
  isSearching: state.products.isFetching,
  searchedProducts: state.products.searchedProducts,
  searchedProductsPagination: state.products.searchedProductsPagination,
  searchedVariants: state.products.searchedVariants,
  selectedProductList: state.products.selectedProductList,
  categories: state.categories,
  assignments: state.assignments
});

const mapDispatchToProps = (dispatch) => ({
  submitSearch: (payload, searchTerm, inStockFilter, purchasingDisabledFilter, categoryFilter, page) => dispatch(searchProducts(payload, searchTerm, inStockFilter, purchasingDisabledFilter, categoryFilter, page)),
  loadCategories: (payload) => dispatch(getCategories(payload)),
  setSelectedProductList: (items) => dispatch(updateSelectedItems(items)),

  createAssignments: (payload, supplierId, assignments, assignmentValues) => dispatch(assignmentsCreate(payload, supplierId, assignments, assignmentValues)),
  resetAssignments: () => dispatch(reset()),
  resetProductSearch: () => dispatch(resetProducts()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateSupplierAssignments);